import * as t from 'io-ts';
import {
  Offer,
  TopRoutes,
  TopOperators,
  Template,
  MySafetyHtmls,
  LeaveIntentOffer,
  Route,
  BusAmenities,
  BusReviews,
  SeoOfferData,
} from '../../pages/runtime-typechecker';

export const OperatorInfo = t.type({
  busAmenities: t.array(BusAmenities),
  busTypes: t.array(t.string),
  busReviews: t.array(BusReviews),
  busImagesUrl: t.array(t.string),
  noOfRoutes: t.number,
  noOfBuses: t.number,
  areaServed: t.array(t.string),
  ownedBy: t.string,
  headOffice: t.string,
});

export const OperatorData = t.type({
  id: t.number,
  operatorName: t.string,
  description: t.union([t.string, t.undefined, t.null]),
  operatorInfo: OperatorInfo,
});

export const otherRoutes = t.type({
  otherRoutes: t.array(Route),
});
export const CityData = t.type({
  id: t.number,
  name: t.string,
  description: t.union([t.string, t.null]),
  url: t.string,
  code: t.string,
  nameForUrl: t.string,
  topRoutesFromCity: t.array(TopRoutes),
  topRoutesToCity: t.array(TopRoutes),
  otherRoutesFromCity: otherRoutes,
  otherRoutesToCity: otherRoutes,
  cityBoardingPointsList: t.union([t.array(t.string), t.undefined]),
  cityDropPointsList: t.union([t.array(t.string), t.undefined]),
});

export const CityOperatorTemplateDataChecker = t.type({
  id: t.number,
  created: t.string,
  modified: t.string,
  cityName: t.string,
  cityCode: t.string,
  operatorName: t.string,
  description: t.string,
  isActive: t.boolean,
  htmlRefreshDate: t.union([t.string, t.null]),
  url: t.string,
  offers: t.array(Offer),
  cityData: CityData,
  operatorData: OperatorData,
  templateData: Template,
  status: t.string,
  mySafetyHtmls: MySafetyHtmls,
  leaveIntentOffers: t.array(LeaveIntentOffer),
  seoOfferData: t.array(SeoOfferData),
  schemaInfo: t.union([t.undefined, t.null, t.string]),
});
export type CityOperatorTemplateData = t.TypeOf<
  typeof CityOperatorTemplateDataChecker
>;
